 
// src/redux/reducers/designationReducer.js
import {
    FETCH_DESIGNATION_FAILURE,
    FETCH_DESIGNATION_REQUEST,
    FETCH_DESIGNATION_SUCCESS, 
    SET_SELECTED_DESIGNATION 
  } from '../types';
  
  const initialState = {
    loading: false,
    designationList: [],
    selectedDesignationId: null, 
    error: null,
  };
  
  const designationReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_DESIGNATION_REQUEST:
        return { ...state, loading: true };
      case FETCH_DESIGNATION_SUCCESS:
        return { ...state, loading: false, designationList: action.payload };
      case FETCH_DESIGNATION_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_DESIGNATION:
        return { ...state, selectedDesignationId: action.payload };
      default:
        return state;
    }
  };
  
  export default designationReducer;
  